export default "__VITE_ASSET__$sPC5Nn$__"